import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

import { parseQueryString } from '../../shared/utils';


function mapStateToProps(state,props){
  return {
    isInvite:props.location.pathname.indexOf('invite') >= 0,
    queryStringParams:parseQueryString(props.location.search)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to OnboardingHiImMary
  return bindActionCreators({},dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/OnboardingHiImMary/connect.js